import React from 'react';
import { Link } from 'react-router-dom';
import { DatabaseIcon, ArrowRightIcon, ServerIcon } from 'lucide-react';
export function PlatformDataPage() {
  return <div className="w-full" data-id="element-7497">
      {/* Hero */}
      <section className="bg-gradient-to-br from-orange-900 via-orange-800 to-amber-900 text-white py-24" data-id="element-7498">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7499">
          <div className="max-w-3xl" data-id="element-7500">
            <h1 className="text-5xl font-bold mb-6" data-id="element-7501">Data Platform</h1>
            <p className="text-xl text-orange-100 mb-8" data-id="element-7502">
              Enrichment, identity resolution, consent management, data
              freshness, and API activation all in one platform.
            </p>
            <div className="flex items-center gap-4" data-id="element-7503">
              <Link to="/integrations/catalog" className="px-6 py-3 bg-white text-orange-900 rounded-lg hover:bg-orange-50 font-medium" data-id="element-7504">
                Explore Integrations
              </Link>
              <Link to="/website/contact" className="px-6 py-3 border border-white text-white rounded-lg hover:bg-white/10 font-medium" data-id="element-7505">
                Request Demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Features */}
      <section className="py-20 bg-white" data-id="element-7506">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7507">
          <div className="text-center mb-16" data-id="element-7508">
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-7509">
              Data Capabilities
            </h2>
            <p className="text-lg text-gray-600 mt-4" data-id="element-7510">
              Enterprise-grade data foundation for your GTM operations
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-7511">
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-7512">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4" data-id="element-7513">
                <DatabaseIcon className="w-6 h-6 text-orange-600" data-id="element-7514" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-7515">Data Enrichment</h3>
              <p className="text-gray-600" data-id="element-7516">
                Enrich your data with firmographic, technographic, and intent
                signals.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-7517">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4" data-id="element-7518">
                <ServerIcon className="w-6 h-6 text-orange-600" data-id="element-7519" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-7520">
                Identity Resolution
              </h3>
              <p className="text-gray-600" data-id="element-7521">
                Connect identities across systems for a unified customer view.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-7522">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4" data-id="element-7523">
                <DatabaseIcon className="w-6 h-6 text-orange-600" data-id="element-7524" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-7525">API Activation</h3>
              <p className="text-gray-600" data-id="element-7526">
                Activate your data across your entire GTM tech stack via APIs.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA */}
      <section className="py-16 bg-orange-50" data-id="element-7527">
        <div className="max-w-5xl mx-auto px-6 text-center" data-id="element-7528">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-7529">
            Ready to unlock your data?
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-7530">
            Get started with our Data Platform and transform your GTM data
            foundation
          </p>
          <Link to="/integrations/catalog" className="px-8 py-4 bg-orange-600 text-white rounded-lg hover:bg-orange-700 font-medium inline-flex items-center gap-2" data-id="element-7531">
            Explore Integrations
            <ArrowRightIcon className="w-5 h-5" data-id="element-7532" />
          </Link>
        </div>
      </section>
    </div>;
}